export default {"src":"/_next/static/media/play-secondary.e147a785.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};